export default __webpack_public_path__ + "images/complaint-empty-positive.png";